
const getHeaders = (session)  =>{
    let headers = {
        'Content-Type': 'application/json'
    };

    if (session.status === 'authenticated') {
        if (session.data.accessToken) {
            headers = {
                ...headers,
                'Authorization': `Bearer ${session.data.accessToken}`
            };
        }
    }

    return headers;
}

export default getHeaders;